import * as THREE from "three";
import { mergeGeometries } from "three/examples/jsm/utils/BufferGeometryUtils.js";

export type FenceStyle = "wood" | "mesh" | "glass";

const woodPost = new THREE.MeshStandardMaterial({ name: "fence-wood-post", color: "#7a5636", roughness: 0.9, metalness: 0 });
const woodRail = new THREE.MeshStandardMaterial({ name: "fence-wood-rail", color: "#9a7149", roughness: 0.9, metalness: 0 });
const metal = new THREE.MeshStandardMaterial({ name: "fence-metal", color: "#2f3a33", roughness: 0.6, metalness: 0.3 });
const mesh = new THREE.MeshStandardMaterial({
  name: "fence-mesh",
  color: "#3d4a42",
  roughness: 0.8,
  metalness: 0.2,
  transparent: true,
  opacity: 0.35,
  depthWrite: false,
  side: THREE.DoubleSide,
});
const glass = new THREE.MeshStandardMaterial({
  name: "fence-glass",
  color: "#cfe6f0",
  roughness: 0.1,
  metalness: 0,
  transparent: true,
  opacity: 0.35,
  depthWrite: false,
  side: THREE.DoubleSide,
});

function box(width: number, height: number, depth: number, x: number, y: number, z: number): THREE.BufferGeometry {
  const geometry = new THREE.BoxGeometry(width, height, depth);
  geometry.translate(x, y, z);
  return geometry.toNonIndexed();
}

function merged(geometries: THREE.BufferGeometry[], material: THREE.Material, name: string): THREE.Mesh {
  const result = new THREE.Mesh(mergeGeometries(geometries), material);
  result.name = name;
  return result;
}

function posts(width: number, spacing: number): number[] {
  const count = Math.max(1, Math.ceil(width / spacing));
  return Array.from({ length: count + 1 }, (_, i) => -width / 2 + (width * i) / count);
}

/** Clôture rectiligne de `width` mètres le long de x, centrée sur l'origine. */
export function buildFence(width: number, style: FenceStyle): THREE.Group {
  const root = new THREE.Group();
  if (style === "wood") {
    root.add(merged(posts(width, 2).map((x) => box(0.12, 1.3, 0.12, x, 0.65, 0)), woodPost, "FencePosts"));
    root.add(merged([0.5, 1.05].map((y) => box(width, 0.12, 0.06, 0, y, 0.07)), woodRail, "FenceRails"));
  } else if (style === "mesh") {
    root.add(merged([
      ...posts(width, 2.5).map((x) => box(0.07, 2.2, 0.07, x, 1.1, 0)),
      box(width, 0.05, 0.05, 0, 2.17, 0),
      box(width, 0.05, 0.05, 0, 0.05, 0),
    ], metal, "FenceFrame"));
    root.add(merged([box(width, 2.1, 0.01, 0, 1.1, 0)], mesh, "FenceMesh"));
  } else {
    root.add(merged([
      ...posts(width, 1.5).map((x) => box(0.05, 1.6, 0.05, x, 0.8, 0)),
      box(width, 0.05, 0.07, 0, 1.6, 0),
    ], metal, "FenceFrame"));
    root.add(merged([box(width, 1.5, 0.02, 0, 0.8, 0)], glass, "FenceGlass"));
  }
  return root;
}
